import {
  ActionTypes,
  FetchUserStatusFailAction,
  FetchUserStatusStartAction,
  FetchUserStatusUpdateAction,
  FetchUserStatusSuccessAction,
  cleanUserStatusAction,
  UpdatePromotionsAvailableAction,
} from './types';

import { NextUserStatus } from '@/types/userStatus';

const fetchUserStatusSuccess = (payload: NextUserStatus): FetchUserStatusSuccessAction => ({
  type: ActionTypes.FETCH_USER_STATUS_SUCCESS,
  payload,
});
const cleanUserStatus = (): cleanUserStatusAction => ({
  type: ActionTypes.CLEAN_USER_STATUS,
});
const fetchUserStatusStart = (): FetchUserStatusStartAction => ({
  type: ActionTypes.FETCH_USER_STATUS_START,
});
const fetchUserStatusNextUpdate = (): FetchUserStatusUpdateAction => ({
  type: ActionTypes.FETCH_USER_STATUS_UPDATE,
});
const fetchUserStatusFail = (payload: string): FetchUserStatusFailAction => ({
  type: ActionTypes.FETCH_USER_STATUS_FAIL,
  payload,
});
const updatePromotionsAvailable = (payload: number): UpdatePromotionsAvailableAction => ({
  type: ActionTypes.UPDATE_PROMOTIONS_AVAILABLE,
  payload,
});

export {
  fetchUserStatusSuccess,
  fetchUserStatusStart,
  fetchUserStatusNextUpdate,
  fetchUserStatusFail,
  updatePromotionsAvailable,
  cleanUserStatus,
};
